<div class="map-container"
  leaflet
  [leafletOptions]="options"
  (leafletMapReady)="onMapReady($event)"
  (leafletClick)="mapClicked($event)">
</div>
<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
<div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
  <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
  styleClass="p-button-warning"></p-button>
 <p-button  icon="pi pi-check" label="Conferma"
  class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="!positionHasChanged "></p-button>
</div>